import type { ClientConfigPublic, CommonConfigPublic, StackConfigPublic } from '@takeshape/infra';
import type { Pattern } from '@takeshape/schema';
import configuration from './configuration.json';

// Provided by bundler since they can vary
export const baseUrl = process.env.APP_BASE_URL;
export const apiEndpoint = process.env.API_BASE_URL;
export const apiCdnEndpoint = process.env.CDN_BASE_URL;
export const env = process.env.TS_ENV;
export const variant = process.env.TS_VARIANT;
export const version = process.env.VERSION;
export const build = process.env.BUILD;

export type Configuration = StackConfigPublic & CommonConfigPublic & ClientConfigPublic;
export const {
  maintenance,
  billingEnabled,
  branding,
  context,
  googleAuthClientId,
  googleAuthEnabled,
  pusherAppId,
  pusherCluster,
  pusherKey,
  segmentWriteKey,
  featureDefaultTimezone,
  googleAuthScope,
  googlePlacesApiKey,
  netlifyClientId,
  recaptchaSiteKey,
  sentryDSN,
  stripePublicKey,
  signupMode,
  featuredProviders,
  featuredCategories,
  hiddenProviders
} = configuration as Configuration;
export const { assetBaseUrl, imageBaseUrl } = context;

export const defaultImageConfig = { auto: 'format,compress' };

export const patterns: Pattern[] = [
  {
    id: 'rag-example',
    uri: 'https://github.com/takeshape/rag-example/tree/main',
    metadata: {
      name: 'RAG Example',
      description: 'An example of how to use RAG with Shopify and OpenAI',
      icon: 'dollar-sign',
      color: '#95bf46',
      categories: ['AI', 'RAG', 'OpenAI', 'Shopify']
    }
  },
  {
    id: 'penny',
    uri: 'https://github.com/takeshape/penny/tree/main/.takeshape/pattern',
    metadata: {
      name: 'Penny Ecommerce',
      description: 'An e-commerce starter kit aggregating 14 third-party services',
      icon: 'dollar-sign',
      color: '#95bf46',
      categories: ['e-commerce', 'Shopify']
    }
  },
  {
    id: 'shape-books',
    uri: 'https://github.com/takeshape/patterns/tree/main/shape-books',
    metadata: {
      name: 'Shape Books',
      description: 'A content modeling showcase',
      icon: 'book-open',
      categories: ['examples', 'quickstart']
    }
  }
];
